module.exports = __webpack_public_path__ + "zm.fb8a2ed6876af4874820.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/zm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/zm.svg
// module chunks = styles